export function getFeedbackEntryYear(entry) {
  const rawValue = String(entry?.event_date || '').trim();
  const matchedYear = rawValue.match(/^(\d{4})/);

  if (matchedYear) {
    return Number.parseInt(matchedYear[1], 10);
  }

  const parsedDate = new Date(rawValue);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate.getFullYear();
}

export function getAvailableFeedbackYears(entries = []) {
  return [...new Set(entries.map((entry) => getFeedbackEntryYear(entry)).filter(Number.isInteger))]
    .sort((left, right) => right - left);
}

export function filterFeedbackEntriesByYears(entries = [], selectedYears = []) {
  if (!selectedYears.length) {
    return entries;
  }

  const allowedYears = new Set(selectedYears.map((value) => String(value)));
  return entries.filter((entry) => allowedYears.has(String(getFeedbackEntryYear(entry) || '')));
}

export function filterIncidentEntries(entries = [], selectedYears = [], selectedInjuryTypes = []) {
  const yearFilteredEntries = filterFeedbackEntriesByYears(entries, selectedYears);

  if (!selectedInjuryTypes.length) {
    return yearFilteredEntries;
  }

  return yearFilteredEntries.filter((entry) => selectedInjuryTypes.includes(entry.payload?.injuryType));
}